import React from 'react'
import { useState, useEffect } from 'react'
import { Routes, Route, NavLink, useNavigate, useLocation, useParams } from 'react-router-dom'
import SecInsurance from '../pages/SecInsurance';
import PatPersonalInfo from '../pages/PatientContacts/PatPersonalInfo';
import PatEmergencyContact from '../pages/PatientContacts/PatEmergencyContact';
import { useDispatch, useSelector } from 'react-redux';
import { APIConstants, CommonAPIConstants } from '../utilities/Constants'
import AppointmentSection from '../pages/AppointmentSection';
import { setDemoGraphyData } from '../redux/actions/userActions';


const PatientContacts = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('');
  const [claimCountData, setclaimCountData] = useState('');

  const [patientId, setPatientId] = useState(null);
  const [secondaryInsData, setSecondaryInsData] = useState([]);

  const dispatch = useDispatch();
  const { id } = useParams();

  const DemoGraphyData = useSelector((state) => state.user.demoDetails);


  useEffect(() => {
    if (DemoGraphyData && Object.keys(DemoGraphyData).length > 0) {
      localStorage.setItem("demoData", JSON.stringify(DemoGraphyData));
    }
  }, [DemoGraphyData]);



  const userData = useSelector((state) => state.user.user);


  var userPracticeID = userData ? userData.practiceID : null;

  var userId = userData ? userData.userID : null;

  const sAuthToken = useSelector((state) => state.user.token);

  // const claimId = useSelector((state) => state.user.claimId);


  useEffect(() => {
    const storedPatientId = localStorage.getItem("PatientId");
    setPatientId(storedPatientId);
  }, []);




  useEffect(() => {
    document.title = 'Patient Portal'

    const currentTab = location.pathname.split('/').pop();
    setActiveTab(currentTab);


    if (!currentTab) {
      navigate(`${id}/Personal-info`);
    }
  }, [location, id, navigate]);





  const handleGetPatDemographyData = async () => {



    const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.GetPatientDemography}?PatientId=${id}`;



    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sAuthToken}`
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {



        const parsedData = JSON.parse(data)
        const demodata = JSON.parse(parsedData)
        dispatch(setDemoGraphyData(demodata))
        localStorage.setItem("demoData", JSON.stringify(parsedData));


      })
      .catch((error) => {
        console.error('Error fetching:', error);
      });
  }






  useEffect(() => {

    handleGetPatDemographyData();



  }, [])






  const handleGetPatInsurance = async () => {

    const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.GetPatInsuranceDetails}?PatientId=${id}`;

    console.log("URL: ", url);

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sAuthToken}`
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {



        const parsedData = JSON.parse(data)
        const filterData = parsedData.filter(item => item.InsType == 2)


        setSecondaryInsData(filterData);


        console.log("GetPrimaryInsurance of" + CommonAPIConstants.GetPatInsuranceDetails, filterData);




      })
      .catch((error) => {
        console.error('Error fetching:', error);
      });
  }




  useEffect(() => {

    handleGetPatInsurance();


  }, [])









  const handleTabClick = (tab) => {
    setActiveTab(tab);
    navigate(`/PatientContacts/${id}/${tab}`);
  };



  return (
    <>

      <div className='d-flex bg-white'>


        <div style={{ width: '100%' }}>

          <ul className="nav nav-pills mt-1 ml-5" id="pills-tab" role="tablist">


            <li className="nav-item">
              <a
                className={`nav-link p-1 tab-style ${activeTab === 'Personal-info' ? 'active-tab' : ''}`}
                role="tab"
                aria-controls="pills-profile"
                aria-selected={activeTab === 'Personal-info'}
                onClick={() => handleTabClick('Personal-info')}
              >
                Personal Information
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link p-1 tab-style ${activeTab === 'Emergency-contacts' ? 'active-tab' : ''}`}

                role="tab"
                aria-controls="pills-contact"
                aria-selected={activeTab === 'Emergency-contacts'}
                onClick={() => handleTabClick('Emergency-contacts')}
              >
                <label>Emergency Contact</label>
              </a>
            </li>


          </ul>



          <div className="tab-content" id="pills-tabContent" >
            <Routes>
              <Route path="Personal-info" element={<PatPersonalInfo />} />
              <Route path="Emergency-contacts" element={<PatEmergencyContact />} />


            </Routes>
          </div>
        </div>
      </div>
    </>
  )
}

export default PatientContacts
